import { useQuery } from '@tanstack/react-query';

import { getYourOwnUser, type GetYourOwnUserResponse } from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';
import queryKeys from '@/queries/queryKeys';
import type { QueryOptions } from '@/types/react-query';

export default function useMe(options?: QueryOptions<GetYourOwnUserResponse>) {
  return useQuery({
    queryKey: queryKeys.me(),
    queryFn: () => getYourOwnUser(wgApi),
    ...options,
  });
}
